import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { tap } from "rxjs/operators";

import { BehaviorSubject, firstValueFrom } from "rxjs";

import { AppConfig } from "../app.config";

@Injectable({ providedIn: "root" })
export class CharacteristicSearchService {
  private serviceUrl: string;
  private headers: HttpHeaders = new HttpHeaders({
    "Content-Type": "application/json"
  });

  private plants = new BehaviorSubject<any[]>([]);

  private otherFiltersSource = new BehaviorSubject<any[]>([]);
  otherFilters$ = this.otherFiltersSource.asObservable();

  private basicFilterPlantIdsSource = new BehaviorSubject<number[]>([]);
  private advancedFilterPlantIdsSource = new BehaviorSubject<number[]>([]);

  private plantIdsSource = new BehaviorSubject<number[]>([]);
  plantIds$ = this.plantIdsSource.asObservable();

  constructor(
    private appConfig: AppConfig,
    private http: HttpClient
  ) {
    this.serviceUrl = this.appConfig.getPlantsAPIUrl();
  }

  fetchPlants() {
    const url = this.serviceUrl + "characteristicSearchResults";

    return this.http
      .get<any[]>(url, { headers: this.headers })
      .pipe(tap((response) => this.plants.next(response)));
  }

  getPlants() {
    return this.plants.asObservable();
  }

  getPlantIds(): number[] {
    return this.plantIdsSource.getValue();
  }

  updateOtherFilters(newFilters: any[]): void {
    this.otherFiltersSource.next(newFilters);
  }

  updateBasicFilterPlantIds(newPlantIds: number[]): void {
    this.basicFilterPlantIdsSource.next(newPlantIds);
    this.updateCombinedPlantIds();
  }

  updateAdvancedFilterPlantIds(newPlantIds: number[]): void {
    this.advancedFilterPlantIdsSource.next(newPlantIds);
    this.updateCombinedPlantIds();
  }

  clearBasicFilterPlantIds(): void {
    this.basicFilterPlantIdsSource.next([]);
    this.updateCombinedPlantIds();
  }

  clearAdvancedFilterPlantIds(): void {
    this.advancedFilterPlantIdsSource.next([]);
    this.updateCombinedPlantIds();
  }

  getCharacteristicSearchFilters(filterType?: string): Promise<any[]> {
    const url = this.serviceUrl + "characteristicSearchFilterResults";
    let params = new HttpParams();

    if (filterType) {
      params = params.append("type", filterType);
    }
    return firstValueFrom(this.http.get<any[]>(url, { headers: this.headers, params })).catch(
      (error) => {
        console.error("An error occurred", error);
        return Promise.reject(error.message || error);
      }
    );
  }

  downloadResults(): Promise<Blob> {
    const url = this.serviceUrl + "characteristicSearchResultsDownload";
    return firstValueFrom(this.http.get<Blob>(url, { responseType: "blob" as "json" }));
  }

  private combinePlantIds(): number[] {
    return [
      ...this.basicFilterPlantIdsSource.getValue(),
      ...this.advancedFilterPlantIdsSource.getValue()
    ];
  }

  private updateCombinedPlantIds(): void {
    this.plantIdsSource.next(this.combinePlantIds());
  }
}
